export default "__VITE_ASSET__Cpdvzc0y__"